
export class Constants {

  public static REST_API_MAIN: string = 'https://lms-connect.achatsocial.com';   // inet
  public static REST_API_SW: string = 'https://releep.achatsocial.com:1243'; // bangwa

}
